// `order` is spaced out (100s) rather than sequential so an academy-defined
// custom stage (see customLeadStages, StagesContext) can be inserted at any
// point in the pipeline by picking a value between two of these, without
// renumbering anything here. isSystem stages carry hardcoded behavior
// elsewhere (functions/index.js — auto-advance, conversion, stale-lead
// exclusions) keyed on their literal `key`, so an admin can relabel one
// (change what it's called) and, for the ones not in
// PROTECTED_LEAD_STAGE_KEYS below, hide it from their own pipeline (see
// deleteSystemStage/restoreSystemStage, StagesContext) — but the key itself
// never changes.
export const LEAD_STAGES = [
  { key: 'prospect',         label: 'Prospect',                 order: 100, isSystem: true, bg: '#eef2ff', color: '#6366f1' },
  { key: 'lead',              label: 'Lead',                    order: 200, isSystem: true, bg: '#f5f3ff', color: '#8b5cf6' },
  { key: 'awaitingDecision', label: 'Awaiting Coaches Decision', order: 300, isSystem: true, bg: '#fffbeb', color: '#f59e0b' },
  { key: 'playerAccepted',   label: 'Player Accepted',           order: 400, isSystem: true, bg: '#f0fdf4', color: '#22c55e' },
  { key: 'sendContract',     label: 'Contract Sent',              order: 500, isSystem: true, bg: '#fdf4ff', color: '#c026d3' },
  { key: 'onHold',           label: 'On Hold',                   order: 600, isSystem: true, bg: '#fff7ed', color: '#ea580c' },
  { key: 'lost',             label: 'Lost',                      order: 700, isSystem: true, bg: '#fef2f2', color: '#ef4444' },
];

// Only 'lost' drops off the day-to-day Kanban — playerAccepted is an active
// waiting-on-signature state now (contract has been sent, not yet signed),
// and onHold is a paused-but-actionable lead, not a dead end.
export const ACTIVE_LEAD_STAGES = LEAD_STAGES.filter((s) => s.key !== 'lost');

export const LEAD_STAGE_MAP = Object.fromEntries(LEAD_STAGES.map((s) => [s.key, s]));

// 'sendContract' is the unconditional auto-advance target when a contract
// is sent (functions/index.js forwardLeadStage) — hiding it wouldn't stop
// that write, just make the result vanish from the board. Mirrors
// PROTECTED_SYSTEM_STAGES.lead in functions/index.js — keep in sync.
export const PROTECTED_LEAD_STAGE_KEYS = ['sendContract'];

export function leadStageLabel(key) {
  return LEAD_STAGE_MAP[key]?.label ?? key;
}
